module.exports = __webpack_public_path__ + "img/i_empty_ready.66852553.svg";